module.exports = __webpack_public_path__ + "static/media/md-log-in.44896c0a.svg";